if (!customElements.get('products-showcase')) {
  customElements.define(
    'products-showcase',
    class ProductsShowcase extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';
        if (!this.enableSlider) return;

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderInstance = null;

        this.initSlider();
      }

      initSlider() {
        const spaceBetween = parseInt(this.dataset.itemGap, 10) || 12;
        const spaceBetweenDesktop = parseInt(this.dataset.itemGapDesktop, 10) || spaceBetween;
        const container = this.querySelector('.swiper');

        // nombre de slides (utile pour loop)
        const slidesCount = container ? container.querySelectorAll('.swiper-slide').length : 0;

        this.sliderOptions = {
          // Laisse le CSS décider (70vw)
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween,
          autoHeight: false,

          // LOOP solide pour largeurs variables
          loop: true,
          // dupliquer suffisamment d’items pour éviter l’arrêt en bout
          loopedSlides: slidesCount,            // toutes les slides
          loopedSlidesLimit: false,             // ne limite pas selon viewport
          loopAdditionalSlides: Math.min(6, Math.max(3, Math.ceil(slidesCount / 2))),
          loopPreventsSliding: false,           // autorise le slide même si calcul Swiper doute
          watchSlidesProgress: true,
          normalizeSlideIndex: true,
          // important: ne coupe pas la boucle quand “pas assez de slides”
          watchOverflow: false,

          navigation: {
            nextEl: this.section.querySelector('.swiper-button-next'),
            prevEl: this.section.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.section.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },

          breakpoints: {
            1024: { spaceBetween: spaceBetweenDesktop },
          },

          on: {
            init: (sw) => {
              // Nettoyage de toute largeur inline injectée
              sw.slides.forEach((el) => {
                el.style.width = '';
                el.style.flex = '';
              });
            },
            afterInit: (sw) => {
              sw.updateSlides(); // recalcule slides + duplicatas
              sw.updateSize();
              sw.updateSlidesClasses();
              sw.updateProgress();
              sw.update();       // final
            },
            resize: (sw) => {
              sw.updateSize();
              sw.updateSlides();
              sw.update();
            },
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(container, this.sliderOptions);
        this.sliderInstance.init();

        // A11y: focus => amener la bonne slide (version loop)
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);
        focusableElements.forEach((el) => {
          el.addEventListener('focusin', () => {
            const slide = el.closest('.swiper-slide');
            if (!slide) return;
            const idx = this.sliderInstance.slider.slides.indexOf(slide);
            if (idx >= 0 && typeof this.sliderInstance.slider.slideToLoop === 'function') {
              this.sliderInstance.slider.slideToLoop(idx);
            } else if (idx >= 0) {
              this.sliderInstance.slider.slideTo(idx);
            }
          });
        });
      }
    }
  );
}
